import Popup from '@/components/Common/DesignSystem/Popup/Popup';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext } from 'react';

const NotAvailablePopup: FC = () => {
  const store = useContext(NolPromotionStoreCtx);

  return (
    <Popup
      isOpen={store.isNotAvailableModalOpen}
      mainBtn={{
        label: '닫기',
        onClick: () => (store.isNotAvailableModalOpen = false),
      }}
    >
      {{ title: '서비스 오픈을 준비 중입니다. 잠시만 기다려주세요' }}
    </Popup>
  );
};

export default observer(NotAvailablePopup);
